import http from './http'

export function fetchOrgTree() {
  return http.get('/org/tree')
}

export function fetchUsersByDepartment(departmentId) {
  return http.get(`/org/departments/${departmentId}/users`)
}